import "./CustomGenericModal.css";

import Modal from "@mui/material/Modal";
import CustomButton from "./CustomButton";
import InfoIconImgSrc from "../../assets/image/png/info.png";
import TickconImgSrc from "../../assets/image/png/tick.png";
import NegativeIconImgSrc from "../../assets/image/png/error.png";
import Fade from "@mui/material/Fade";

import { CircularProgress } from "@mui/material";


interface CustomPopupProps {
    type: "positive" | "success" | "negative" | "error";
    message: string | any[];
    leftButtonText?: string;
    rightButtonText?: string;
    onLeftButtonClick?: () => void;
    onRightButtonClick?: () => void;
    onClose?: () => void;
    modalOpen: boolean;
    loading?: boolean;
    showSummary?: boolean;
    leftButtonPadding?: string;
    confirmedOrders?: number;
    partiallyConfirmedOrders?: number;
    unavailableOrders?: number;
    filterConfirmedOrders?: () => void;
    filterPartiallyConfirmedOrders?: () => void;
    filterUnavailableOrders?: () => void;
    insideBulkInvoice?: boolean
  }

  const customStyle = {
    width: 22,
    height: 22,
    color: "#fff",
    marginTop: "5px",
  };

export const CustomBulkModal: React.FC<CustomPopupProps> = ({
    type,
    message,
    leftButtonText,
    rightButtonText,
    onLeftButtonClick,
    onRightButtonClick,
    onClose,
    modalOpen,
    loading,
    showSummary,
    confirmedOrders,
    partiallyConfirmedOrders,
    unavailableOrders,
    filterConfirmedOrders,
    filterPartiallyConfirmedOrders,
    filterUnavailableOrders,
    insideBulkInvoice = false,
  }) => {
    const getTypeIcon = (type: string) => {
      switch (type) {
        case "positive":
          return InfoIconImgSrc;
        case "success":
          return TickconImgSrc;
        case "negative":
          return NegativeIconImgSrc;
        case "error":
          return NegativeIconImgSrc;
        default:
          return "";
      }
    };
  
    return (
      <Modal
        open={modalOpen}
        onClose={onClose}
        closeAfterTransition
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Fade in={modalOpen}>
          <div className={"CustomGenericModal_popup-container"} style={{width:"500px"}}>
            <div className="CustomGenericModal_popup-content">
              <div className="CustomGenericModal_popup-sign">
                {<img src={getTypeIcon(type)} />}
              </div>
              <div className="CustomGenericModal_popup-message" style={{marginBottom: "10px"}}>
                {Array.isArray(message)
                  ? message?.map((error: any) => {
                      const { ErrorCode, ErrorMessage } = error || {};
                      return (
                        <p style={{ fontWeight: 500, marginBottom: "10px" }}>
                          {`Error ${ErrorCode}`}:{" "}
                          <span style={{ fontWeight: 450, color: "#707070" }}>
                            {ErrorMessage}
                          </span>
                        </p>
                      );
                    })
                  : typeof message === "string"
                  ? message
                  : "Some error occurred"}
              </div>
              {showSummary && (
              <ul style={{ display: "flex", textAlign: "start", flexDirection:"column", color:"#707070", fontSize: "13px" }}>
                {confirmedOrders !== undefined && confirmedOrders !== null && confirmedOrders !== 0 && (
                  <li>
                    <span style={{ textDecoration: 'underline', fontStyle: 'italic', cursor: 'pointer' }} onClick={() => filterConfirmedOrders?.()}>
                      {confirmedOrders}{`${insideBulkInvoice ? "" : " Pending"}`} {`${confirmedOrders > 1 ? "Orders" : "Order"}`}           
                    </span>{' '}
                    <span> {`will be ${insideBulkInvoice ? "fully invoiced" : "fully confirmed"}`}</span>
                  </li>
                )}
                {partiallyConfirmedOrders !== undefined && partiallyConfirmedOrders !== null && partiallyConfirmedOrders !== 0 &&(
                  <li>
                    <span style={{ textDecoration: 'underline', fontStyle: 'italic', cursor: 'pointer' }} onClick={() => filterPartiallyConfirmedOrders?.()}>
                      {partiallyConfirmedOrders}{`${insideBulkInvoice ? "" : " Pending"}`} {`${partiallyConfirmedOrders > 1 ? "Orders" : "Order"}`} 
                    </span>{' '}
                    <span> {`will be partially ${insideBulkInvoice ? "invoiced" : "confirmed"} due to partial availability of stocks`}</span>
                  </li>
                )}
                {unavailableOrders !== undefined && unavailableOrders !== null && unavailableOrders !== 0 && (
                  <li>
                    <span style={{ textDecoration: 'underline', fontStyle: 'italic', cursor: 'pointer' }} onClick={() => filterUnavailableOrders?.()}>
                      {unavailableOrders}{`${insideBulkInvoice ? "" : " Pending"}`} {`${unavailableOrders > 1 ? "Orders" : "Order"}`} 
                    </span>{' '}
                    <span>{`will be failed due to unavailability of stocks`}</span>
                  </li>
                )}
              </ul>)}
              <div className="CustomGenericModal_popup-buttons">
                {rightButtonText && onRightButtonClick && (
                  <CustomButton
                    onClick={onRightButtonClick}
                    flexGrow={0.4}
                    fontColor="#707070"
                    backgroundColor="#fff"
                    borderColor="#707070"
                  >
                    {rightButtonText}
                  </CustomButton>
                )}
                {leftButtonText && onLeftButtonClick && (
                  <CustomButton
                    onClick={onLeftButtonClick}
                    flexGrow={rightButtonText ? 0.4 : 1}
                  >
                    {loading ? (
                      <CircularProgress style={customStyle} />
                    ) : (
                      leftButtonText
                    )}
                  </CustomButton>
                )}
              </div>
            </div>
            <button className="CustomGenericModal_popup-close" onClick={onClose}>
              ×
            </button>
          </div>
        </Fade>
      </Modal>
    );
  };
  
